// extracted by mini-css-extract-plugin
export default {"container":"gdocsSync_container__FkgM+","dialog":"gdocsSync_dialog__UIMRZ","loading":"gdocsSync_loading__teuMI","errorEmptyMessage":"gdocsSync_errorEmptyMessage__t0Ctc"};